import { gql } from 'apollo-boost';

export const OPEN_BUSINESS = gql`
  mutation BusinessOpen($id: ID!, $clientMutationId: String) {
    business_open(input: { id: $id, clientMutationId: $clientMutationId }) {
      clientMutationId
    }
  }
`;
